// メッセージボックス_OK_CANCEL用棚
import React, { useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  label: string;
  body: JSX.Element;
  ok: string;
  ok_btn_class?: string;
  okCallback: (event: React.MouseEvent) => void;
  open: boolean;
  closeCallback?: () => void;
}

const Dialog: React.FC<Props> = ({
  label,
  body,
  ok,
  ok_btn_class = 'btn-green',
  okCallback,
  open,
  closeCallback,
}) => {
  const handleClickOk = useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    okCallback(event);
  }, []);
  const handleClickClose = () => {
    if (typeof closeCallback !== 'undefined') {
      closeCallback();
    }
  };

  return (
    <div className="dialog">
      <div className="dialog-mask" style={{ display: open ? 'block' : 'none' }}></div>
      <div className="dialog-section" style={{ display: open ? 'block' : 'none' }}>
        <div className="dialog-inner">
          <div className="dialog-contents">
            <div
              className={`
                dialog-close 
                ${typeof closeCallback === 'undefined' ? 'dialog-close-disabled' : ''}
              `}
            >
              <img src="/img/ico_012_sp.png" alt="" onClick={handleClickClose} />
            </div>
            <div className="heading-m">{label}</div>
            <div className="dialog-body">{body}</div>
            <Row className="dialog-button">
              <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                <button
                  className={`c-btn btn-large mx-auto ${ok_btn_class}`}
                  type="button"
                  onClick={handleClickOk}
                >
                  {ok}
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
